<script>
import New from "./New";
import ratingMixin from "@/mixins/ratingMixin";
import { mapActions } from "vuex";

export default {
  mixins: [ratingMixin],
  props: {
    professional_id: {
      type: String,
      required: true
    }
  },

  components: {
    New
  },

  data() {
    return {
      feedbacks: [],
      addFeedback: false,
      error: false,
      snackbar: {
        visible: false,
        message: "",
        color: "",
        button: {
          text: "ok!",
          color: "white"
        }
      },
      preloader: false
    };
  },

  methods: {
    ...mapActions("professionals", ["getFeedbacks", "removeFeedback"]),
    async setFeedbacks() {
      try {
        this.feedbacks = await this.getFeedbacks(this.professional_id);
      } catch (e) {
        this.setSnackbar("Ocorreu um erro ao listar os feedbacks");
      }
    },
    async remove(feedback_id) {
      try {
        this.preloader = feedback_id;
        await this.removeFeedback(feedback_id);
        await this.setFeedbacks();
        this.setSnackbar("Feedback removido com sucesso!", "success");
        this.preloader = false;
      } catch (e) {
        this.preloader = false;
        this.setSnackbar("Ocorreu um erro ao remover o feedback");
      }
    },

    setSnackbar(message, color = "error") {
      this.snackbar.visible = true;
      this.snackbar.color = color;
      this.snackbar.message = message;
    }
  },

  mounted() {
    this.setFeedbacks();
  }
};
</script>

<template>
  <v-content column>
    <v-snackbar
      :color="snackbar.color"
      v-model="snackbar.visible"
      bottom
      :timeout="5000"
    >
      {{ snackbar.message }}
      <v-btn
        :color="snackbar.button.color"
        text
        @click="snackbar.visible = false"
        >{{ snackbar.button.text }}</v-btn
      >
    </v-snackbar>

    <div @click="addFeedback = true" class="new-group">
      <img src="/static/plus.svg" /> Adicionar feedback
    </div>
    <!-- <v-btn color="primary" @click="addFeedback = true">Adicionar feedback</v-btn> -->

    <v-layout class="mt-30" row wrap>
      <div v-for="(feedback, index) in feedbacks" :key="index" class="rating">
        <div class="content-rating">
          <div class="top">
            Nota {{ feedback.rating | intToRating }}
            <div class="bg-rating ml-10">
              <div
                class="stars"
                :style="`width: ${feedback.rating / 100}%`"
              ></div>
            </div>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  :loading="preloader === feedback.id"
                  color="error"
                  @on="on"
                  @click="remove(feedback.id)"
                  text
                  icon
                  small
                >
                  <v-icon small>close</v-icon>
                </v-btn>
              </template>
              <span>remover</span>
            </v-tooltip>
          </div>

          <p v-text="feedback.description"></p>
        </div>
      </div>
    </v-layout>

    <new
      v-if="addFeedback"
      :professional_id="professional_id"
      @close="addFeedback = false"
      @refresh="setFeedbacks"
      @error="setSnackbar"
      @success="setSnackbar(...arguments)"
    />
  </v-content>
</template>

<style scoped>
.bg-rating {
  background: url("https://res.cloudinary.com/joaofnds/image/upload/v1548201143/email%20donamaid/estrela_contorno-01.png")
    no-repeat;
  width: 69px;
  height: 11px;
}

.stars {
  background: url("https://res.cloudinary.com/joaofnds/image/upload/v1548201143/email%20donamaid/estrela_color-01.png")
    no-repeat;
  max-width: 100%;
  height: 100%;
  background-size: auto 100%;
}

.bg-rating.big {
  background-size: 100% 100%;
  width: 138px;
  height: 22px;
}

.rating {
  display: flex;
  flex-direction: row;
  width: calc(50% - 10px);
  margin-bottom: 20px;
}

.rating:nth-child(odd) {
  margin-right: 10px;
}

.rating:nth-child(even) {
  margin-left: 10px;
}

.rating img {
  width: 50px;
  height: 50px;
  border: 2px solid var(--purple);
  border-radius: 100%;
  margin-right: 15px;
}

.content-rating {
  display: flex;
  flex-direction: column;
}

.content-rating .top {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
}

.content-rating p {
  text-align: justify;
  font-size: 13px;
  margin-top: 0;
}

@media (max-width: 768px) {
  .rating {
    width: 100%;
  }
  .content-ratings {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .bg-rating {
    background: url("https://res.cloudinary.com/joaofnds/image/upload/v1548201143/email%20donamaid/estrela_contorno-01.png")
      no-repeat;
    width: 69px;
    height: 11px;
  }

  .stars {
    background: url("https://res.cloudinary.com/joaofnds/image/upload/v1548201143/email%20donamaid/estrela_color-01.png")
      no-repeat;
    max-width: 100%;
    height: 100%;
    background-size: auto 100%;
  }

  .bg-rating.big {
    background-size: 100% 100%;
    width: 138px;
    height: 22px;
  }

  .rating {
    display: flex;
    flex-direction: row;
    width: calc(50% - 10px);
    margin-bottom: 20px;
  }

  .rating:nth-child(odd) {
    margin-right: 10px;
  }

  .rating:nth-child(even) {
    margin-left: 10px;
  }

  .rating img {
    width: 50px;
    height: 50px;
    border: 2px solid var(--purple);
    border-radius: 100%;
    margin-right: 15px;
  }

  .content-rating {
    display: flex;
    flex-direction: column;
  }

  .content-rating .top {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 5px;
  }

  .content-rating p {
    text-align: justify;
    font-size: 13px;
    margin-top: 0;
  }

  @media (max-width: 768px) {
    .rating {
      width: 100%;
    }

    .title {
      font-size: 20px;
    }
  }
  @media (max-width: 480px) {
    .rating,
    .content-rating .top {
      flex-direction: column;
      align-items: center;
    }

    .rating {
      margin-right: 0 !important;
    }

    .content-rating p {
      text-align: center;
    }
  }

  .title {
    font-size: 20px;
  }
}
@media (max-width: 480px) {
  .rating,
  .content-rating .top {
    flex-direction: column;
    align-items: center;
  }

  .rating {
    margin-right: 0 !important;
  }

  .content-rating p {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Ratings/Feedbacks/Index.vue